/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { v4NeuronVotingPowersGetApiV4NeuronVotingPowers } from "../../funcs/v4NeuronVotingPowersGetApiV4NeuronVotingPowers.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV4NeuronVotingPowersRequest$inboundSchema
    .optional(),
};

export const tool$v4NeuronVotingPowersGetApiV4NeuronVotingPowers:
  ToolDefinition<typeof args> = {
    name: "v4-neuron-voting-powers-get-api-v4-neuron-voting-powers",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await v4NeuronVotingPowersGetApiV4NeuronVotingPowers(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
